<template>
    <div>
        <compWrapper :title="$t('erp.deliverychannel.shipper_address_information',{defaultValue:'渠道发货地址信息'})" theme="primary">
			<compFormQuery class="formselect" v-if="type=='query'" :formdata="getBase" :value="formData" :labelWidth="120"></compFormQuery>
			<compFormEdit v-else class="margin-15 clearfix formselect" ref="editform" :formdata="getBase" v-model="formData" :labelWidth="120" />
            <div class="color-error text-center" v-if="this.type!='query'">{{$t('erp.deliverychannel.label_management_tip',{defaultValue:'不填则使用系统默认样式的面单；面单上的referrence1若想出现固定值，请与框内输入固定值；或自定义订单参数作为referrence。但请注意长度，超过35位可能会被截断无法展示。'})}}</div>

            <div v-if="type!='query'" class="text-right margin-right-15">
                <vButton theme="primary" @click="submit">{{$t('global.common.save',{defaultValue:'保存'})}}</vButton>
                <vButton class="margin-left-10" @click="cancel">{{$t('global.common.operate_cancel',{defaultValue:'取消'})}}</vButton>
            </div>
        </compWrapper>
        <compWrapper :title="$t('erp.deliverychannel.tips',{defaultValue:'小贴士'})" theme="error">
            <div class="margin-15">
                <div class="font-16 font-bold margin-bottom-10">{{$t('erp.deliverychannel.order_parameters_glance',{defaultValue:'订单参数一览'})}}</div>
                <div class="margin-bottom-10 font-14">
                    <!-- {{$t('erp.distribution.deliverorderno',{defaultValue:'配货单号'})}}：%delivery_no% <br />
                    {{$t('erp.deliverychannel.Platform_order_num',{defaultValue:'平台订单号'})}}：%order_no% <br />
                    ERP SKU：%erpsku% <br />
                    {{$t('bi.work.task_org_id',{defaultValue:'组织'})}}id: %organization_id% <br/> -->
                    <span v-html="$t('erp.deliverychannel.order_parameters_glance_label',{defaultValue:'标题'})"></span>
                </div>
                <div class="font-16 font-bold margin-bottom-10">{{$t('erp.deliverychannel.standard_format',{defaultValue:'系统标准格式为reference1取配货单号-erp sku，reference2取平台订单号；'})}}</div>
                <div class="font-16 font-bold margin-bottom-10">{{$t('erp.deliverychannel.custom',{defaultValue:'若想改变面单效果，可进行自定义，但必须提前和客服确认，因为有些改变可能会导致仓库增加发货难度'})}}</div>
                <div class="font-14">
                    Reference1    %order_no%   {{$t('erp.deliverychannel.take_order_number',{defaultValue:'表示reference1取平台订单号'})}}<br />
                    Reference2    11819        {{$t('erp.deliverychannel.take_fixed_value',{defaultValue:'表示reference2取固定值11819（比如该渠道的店铺编号）'})}}<br />
                </div>
            </div>
        </compWrapper>
        <vLoading size="large" transfer :loading="loading"></vLoading>
    </div>
</template>

<script>
import { mapState,mapGetters,mapMutations } from "vuex";

import { HttpGetshipmentAddressOne,HttpSaveshipmentAddress } from "@/service/managechannel/managechannel";
import { HttpGetStates } from '@/service/boss/b2corder'

export default {
    props:['activeids','querytype'],
    components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		compFormEdit: () => import("@components/templates/formedit"),
        // compLog: () => import("./log"),
	},
    data(){
        return {
            id: this.$route.query.id || this.activeids,
            type: this.$route.params.type || this.querytype,
            formData:{
            },
            states:[],
            loading:false
        }
    },
    created(){
        this.update()
    },
    computed:{
        ...mapGetters('diction',['getNewAccountIdList']),
        ...mapGetters('dictionary',['getCountryList']),
        getBase(){
            return [
                {
					label: this.$t('global.common.channel',{defaultValue:'渠道'}),
                    key: "channelId",
                    tag: 'Select',
                    class:"height30",
					options: this.getNewAccountIdList,
					props: {
                        filterable: true,
                        clearable:true,
					}
				},
                {
					label: this.$t('erp.deliverychannel.sender',{defaultValue:'发件人'}),
                    key: "sender",
                    required:false,
                    props:{
                        placeholder:this.$t('erp.deliverychannel.default_information',{defaultValue:'不填则默认订单发货仓库真实信息'})
                    },
                },
                {
					label: this.$t('erp.deliverychannel.sender_company',{defaultValue:'发件公司'}),
                    key: "company",
                    required:false,
                    props:{
                        placeholder:this.$t('erp.deliverychannel.default_information',{defaultValue:'不填则默认订单发货仓库真实信息'})
                    },
                },
                {
					label: this.$t('erp.deliverychannel.sender_contact_number',{defaultValue:'发件人联系电话'}),
                    key: "phone",
                    required:false,
                    props:{
                        placeholder:this.$t('erp.deliverychannel.default_information',{defaultValue:'不填则默认订单发货仓库真实信息'})
                    },
                },
                {
					label: this.$t('erp.deliverychannel.sendAddress',{defaultValue:'发件地址'}),
                    key: "address",
                    required:false,
                    props:{
                        placeholder:this.$t('erp.deliverychannel.default_information',{defaultValue:'不填则默认订单发货仓库真实信息'})
                    },
				},

				{
					label: this.$t('erp.deliverychannel.sendCountry',{defaultValue:'发件国家'}),
                    key: "country",
                    tag:'vSelect',
                    options:this.getCountryList,
                    props: {
                        filterable: true,
                        placeholder:this.$t('erp.deliverychannel.default_information',{defaultValue:'不填则默认订单发货仓库真实信息'})
                    },
                    on:{
                        'on-change':(value, label, attach = {})=>{
                            this.getStates(attach.id,'change')
                            // this.numberChange(attach)
                        }
                    },
                    required:false,
                },
                {
					label: this.$t('erp.deliverychannel.sendState',{defaultValue:'发件州'}),
                    key: "state",
                    tag:'AutoComplete',
                    class:"height30",
                    props:{
                        data:this.states,
                        'filter-method':this.filterMethod,
                        placeholder:this.$t('erp.deliverychannel.default_information',{defaultValue:'不填则默认订单发货仓库真实信息'})
                    },
                    required:false,
                },
                {
					label: this.$t('erp.deliverychannel.senCity',{defaultValue:'发件城市'}),
                    key: "city",
                    required:false,
                    props:{
                        placeholder:this.$t('erp.deliverychannel.default_information',{defaultValue:'不填则默认订单发货仓库真实信息'})
                    },
                },
                {
					label: this.$t('erp.b2c.zip_code',{defaultValue:'邮编'}),
                    key: "zipCode",
                    required:false,
                    props:{
                        placeholder:this.$t('erp.deliverychannel.default_information',{defaultValue:'不填则默认订单发货仓库真实信息'})
                    },
                },
                {
					label: this.$t('global.common.notes',{defaultValue:'备注'}),
                    key: "remark",
                    tag:'vTextarea',
                    required:false,
                },
                {
					label: 'Reference1',
                    key: "reference1",
                    required:false,
                },
                {
					label: 'Reference2',
                    key: "reference2",
                    required:false,
                },
            ]
        }
    },
    methods:{
        filterMethod (value, option) {
            return option.toLowerCase().indexOf(value.toLowerCase()) !== -1;
        },
        getStates(codeid,type){
            if(type=='change'){
                this.formData.state=''
            }
            this.states = []
            HttpGetStates({
                "search[EQ_depth]":4,
                "search[EQ_parentId]":codeid
            }).then(res=>{
                let array = res.data
                array.map(item=>{
                    this.states.push(item.code)
                })
                // console.log(this.states)
            },err=>{

            })
        },
        update(){
            if(this.type == 'add') return
            HttpGetshipmentAddressOne({
                id:this.id
            }).then(res=>{
                this.formData = res.data
                let contryone = this.getCountryList.filter(item => { return item.value === res.data.country})[0] || {}
                this.getStates(contryone.attach.id)
            },err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        async submit(){
            let bool1 = await this.$refs.editform.validate()
            if (!bool1) return

            if(!this.formData.sender && !this.formData.company && !this.formData.phone && !this.formData.address && !this.formData.country && !this.formData.state && !this.formData.city && !this.formData.zipCode && !this.formData.reference1 && !this.formData.reference2) {
                this.$VMessage.error('其他内容至少填写一个');
                return
            }

            this.loading=true;
            HttpSaveshipmentAddress({
                ...this.formData,
                orgId:global.SYSID,
            }).then(res=>{
                this.loading=false;
                this.$VMessage.success(res.message);
                this.cancel();
            },err=>{
                this.loading=false;
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        cancel(){
            this.$router.push({
                name: 'deliverychannelList',
            });
        }
    },
}
</script>
